import React from 'react'
import * as rest from '../../services'
import { useDispatch } from 'react-redux'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import {PenaltyAmount} from "../../api";
import {Confirm, ICONS} from "../../components";
import { Dropdown } from 'react-bootstrap';


interface DeleteLoanerInventoryItemProps {
  item: PenaltyAmount
  onDelete: (item: PenaltyAmount) => void
  text?: 'Delete' | 'Return'
}

export const DeletePenaltyAmount: React.FC<DeleteLoanerInventoryItemProps> = ({
  item,
  onDelete,
  text = 'Delete',
}) => {
  const dispatch = useDispatch()

  const handleAction = async () => {
    const service = new rest.PenaltyService(item.url)
    await service.makeDeleteRequest().then(
        res=>{
          onDelete(item)
          dispatch(showSuccessToast('Success', `Penalty item deleted successful.`))
        }
    ).catch(ex=> {
      const message = JSON.stringify(ex?.response?.data || ex)
      dispatch(showErrorToast('Error', message))
    })
  }

  return (
    <Confirm
      onConfirm={handleAction}
      body={`Are you sure you want to mark this Delete Penalty Amount ?`}
      confirmText={`Confirm Delete Penalty Amount Item`}
      confirmBSStyle="danger"
      title={`Delete Penalty Amount`}
      showCancelButton
    >
      <Dropdown.Item eventKey="1">
        {ICONS.DELETE}
      </Dropdown.Item>
    </Confirm>
  )
}
